var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobTop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.078c7.89 5.466 16.46 9.96 25.316 13.085 39.1 13.864 83.73 1.516 113.378-21.114 21.28-16.01 34.982-37.136 43.624-60.049H0v68.078Z",
    fill: "#E8E8D8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobTop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blob-top.10553a566752405072bf48f1f3398335.svg";